import { TranslationResource } from '@backstage/core-plugin-api/alpha';
import { rootTranslations } from './features/root';
import { commonTranslations } from './features/common';
import { permissionsTranslations } from './features/permissions';
import { languageSwitcherTranslations } from './features/languageSwitcher';
import { userMenuTranslations } from './features/userMenu';
import { userSettingsTranslations } from './plugins/userSettings';
import { gitlabTranslations } from './plugins/gitlab';
import { catalogTranslations } from './plugins/catalog';
import { catalogReactTranslations } from './plugins/catalog-react';
import { scaffolderTranslations } from './plugins/scaffolder';
import { apiDocsTranslations } from './plugins/api-docs';
import { catalogGraphTranslations } from './plugins/catalog-graph';
import { catalogImportTranslations } from './plugins/catalog-import';
import { kubernetesTranslations } from './plugins/kubernetes';
import { kubernetesReactTranslations } from './plugins/kubernetes-react';
import { orgTranslations } from './plugins/org';
import { scaffolderReactTranslations } from './plugins/scaffolder-react';
import { searchTranslations } from './plugins/search';
import { searchReactTranslations } from './plugins/search-react';

export const translationResources: TranslationResource[] = [
  rootTranslations,
  commonTranslations,
  permissionsTranslations,
  languageSwitcherTranslations,
  userMenuTranslations,
  userSettingsTranslations,
  gitlabTranslations,
  catalogTranslations,
  catalogReactTranslations,
  scaffolderTranslations,
  apiDocsTranslations,
  catalogGraphTranslations,
  catalogImportTranslations,
  kubernetesTranslations,
  kubernetesReactTranslations,
  orgTranslations,
  scaffolderReactTranslations,
  searchTranslations,
  searchReactTranslations,
];
